export default defineNuxtRouteMiddleware((to, _from) => {
  // A transfer URL from oldversion to new one, so we just redirect this to the root page
  const isHomepageAnalog = ["/v2_loader", "/dashboard", "/home"].includes(to.path)
  if (isHomepageAnalog) {
    return navigateTo("/")
  }
})
